<template>
  <div>
    <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
      <h2 class="mt-n2 text-center">Sign In</h2>

      <div class="grey--text text--darken-1 mt-3">
        <em>Tip: Most pros sign in with their cell phone.</em>
      </div>

      <v-form class="mt-4" @submit.prevent="loginClick" ref="form">
        <v-text-field 
          v-model="user_id"
          :rules="[required]"
          validate-on-blur outlined dense hide-details="auto" class="mt-3"
          label="Cell Phone or Email"
          persistent-placeholder
        />
        <v-text-field
          v-model="password"
          :type="pw_visible ? 'text' : 'password'"
          outlined dense hide-details="auto" class="mt-8"
          label="Password"
          persistent-placeholder
          :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
          @click:append="pw_visible = !pw_visible"
        />
        <div class="ml-3 mt-3">
          <router-link :to="{ name: 'forgot' }">
            Forgot your password?
          </router-link>
        </div>
        <div class="mt-5 d-flex justify-center">
          <v-btn width="60%" type="submit" color="primary">login</v-btn>
        </div>
      </v-form>
    </div>
    <ErrorOverlay
      title="Login Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </div>
</template>
<script>

import { ErrorOverlay } from '@/components/pages'
import { mapActions, mapMutations } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'Login',

  components: { ErrorOverlay },

  data() {
    return {
      user_id: '',
      password: '',
      pw_visible: false,

      // error handling
      loading: false,
      error_dialog: false,
      error_message: '',

      // validation rules
      required,
    }
  },

  methods: {
    ...mapActions('auth', ['login']),
    ...mapMutations('auth', { setAcceptanceKeys: 'SET_ACCEPTANCE_KEYS' }),

    async loginClick() {
      if (this.$refs.form.validate()) {
        const { user_id, password } = this

        const result = await this.login({ user_id, password })
        if (result.ok) {
          this.$router.push({ name: 'home' })
        } else if (result.status == 404) {
          this.error_dialog = true
          this.error_message = "No user found with that email or phone."
        } else if (result.status == 403) {
          this.setAcceptanceKeys(result)
          this.$router.push({ name: 'alerts/accept' })
        } else {
          this.error_dialog = true
          this.error_message = "That username and password don't match, please try again."
        }
      }
    },
  },
}

</script>
